import {Map} from 'immutable';
import {SET_VIEWSTATE, REMOVE_VIEWSTATE} from '../actions/actionTypes';

const initialState = Map();

export function viewstate(state = initialState, {type, payload}) {
  switch (type) {
    case SET_VIEWSTATE: {
      const keyPath = typeof payload.key === "string" ? [payload.key] : payload.key;
      return state.setIn(keyPath, payload.value);
    }
    case REMOVE_VIEWSTATE: {
      const keyPath = typeof payload.key === "string" ? [payload.key] : payload.key;
      return state.deleteIn(keyPath);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/viewstate.js